import React from "react";
import PolymatchResults from "./PolymatchResults";

const PolymatchResults_GraphicDesigning = () => {
  // Pass GraphicDesigning competition data to the results page
  return <PolymatchResults 
    competition="graphicdesigning" 
    competitionHeading="Graphic Designing Competition"
    year="2025"
  />;
};

export default PolymatchResults_GraphicDesigning;
